import type { IconProps } from '../types/IconProps.ts';
export const LockOpen: IconProps = {
    name: 'LockOpen',
    children: [
        `<path d="M20 11H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1M17 6a5.1 5.1 0 0 0-5-4 5 5 0 0 0-5 5v4" />`,
    ]
};